module.exports = __webpack_public_path__ + "static/media/icon_next.c36bf5df.svg";